import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import AddCoachingPerformanceForm from "../../components/AddCoachingPerformanceForm/AddCoachingPerformanceForm";
import Layout from "../../components/shared/Layout/Layout";

const AddCoachingPerformancePage = ({ edit, grades, getGradeList }) => {
  const { id } = useParams();
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Coaching Performance`}>
        {edit && id && grades ? (
          <AddCoachingPerformanceForm grades={grades} />
        ) : (
          <AddCoachingPerformanceForm grades={grades ? grades : []} />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddCoachingPerformancePage);
